import type { BannerState } from './types';

export const selectBanner = (state: { banner: BannerState }) => state.banner;
export const selectBannerVisible = (state: { banner: BannerState }) =>
  state.banner.visible;
